import {
    IBraggBodyGameEventSpinResult,
    IBraggBodyGameEventSpinResultData,
    IBraggSlotSpinResult,
} from "@spawn/backend-adapter-bragg";
import { IBraggBodyFreegameEvent, IBraggBodyFreegameEventSpinResultData, IBraggFreegamesResponse } from "@spawn/freegames";
import { ILevelDataBragg, ILevelsDataBragg } from "@spawn/reveal";

/** @see IBraggBodyGameEventSpinResult */
export interface NrgBraggGameResult extends IBraggBodyGameEventSpinResult {
	data: IBraggBodyGameEventSpinResultData & {
		SLOT: NrgBraggSlotSpinResult;
		SLOT_ORIGINAL?: INrgBraggSlotOriginal;
	};
}

/** @see IBraggSlotSpinResult */
export interface NrgBraggSlotSpinResult extends IBraggSlotSpinResult {
	levelData: ILevelsDataBragg;
	multiplier: number;
}

export interface INrgBraggSlotOriginal extends IBraggSlotSpinResult {
	levelData?: ILevelsDataBragg;
}

/** @see IBraggBodyFreegameEventSpinResult */
export interface NrgBraggFreegameResult extends IBraggBodyFreegameEvent {
	data: IBraggBodyFreegameEventSpinResultData & {
		FREE_SPIN: IBraggFreegamesResponse & ILevelDataBragg;
		SLOT_ORIGINAL?: INrgBraggSlotOriginal;
	};
}
